import { IntegrationDetailPage, IntegrationsPage } from "./index";
import KnowledgeDocumentCreatePage from "./modules/chat/pages/KnowledgeDocumentCreatePage";
import KnowledgeDocumentDetailPage from "./modules/chat/pages/KnowledgeDocumentDetailPage";
import JobSourceClientsPage from "./modules/job-source/pages/JobSourceClientsPage";
import JobSourceWebhooksPage from "./modules/job-source/pages/JobSourceWebhooksPage";
import ModuleDetailPage from "./modules/pages/ModuleDetailPage";
import { ModuleName } from "./utils/module-name";
import { decodeSlug } from "./utils/slug";

import type { RouteConfig } from "@/types/route-types";

/**
 * Integrations feature routes
 */
export const integrationsRoutes: RouteConfig = {
  path: "integrations",
  routeConfigurations: {
    excludeInnerLayout: true,
  },
  children: [
    {
      index: true,
      element: IntegrationsPage,
    },
    {
      path: ":integrationName",
      element: IntegrationDetailPage,
    },
    {
      // Specific route for job-source module with nested children routes
      path: `:integrationName/${ModuleName.JobSource}`,
      element: ModuleDetailPage,
      routeConfigurations: {
        excludeInnerLayout: true,
        title: ({ t }) =>
          t(`integrations.modules.names.${ModuleName.JobSource}`),
      },
      children: [
        {
          index: true,
          redirect: "clients",
        },
        {
          path: "clients",
          element: JobSourceClientsPage,
          routeConfigurations: {
            excludeInnerLayout: true,
          },
        },
        {
          path: "webhooks",
          element: JobSourceWebhooksPage,
          routeConfigurations: {
            excludeInnerLayout: true,
          },
        },
      ],
    },
    {
      path: ":integrationName/:moduleName/new",
      element: KnowledgeDocumentCreatePage,
      routeConfigurations: {
        excludeInnerLayout: true,
      },
    },
    {
      path: ":integrationName/:moduleName/:fileName",
      element: KnowledgeDocumentDetailPage,
      routeConfigurations: {
        excludeInnerLayout: true,
      },
    },
    {
      // Generic route for all other modules (without nested children)
      path: ":integrationName/:moduleName",
      element: ModuleDetailPage,
      routeConfigurations: {
        excludeInnerLayout: true,
        title: ({ t, params }) =>
          t(
            `integrations.modules.names.${decodeSlug(params.moduleName ?? "")}`
          ),
      },
    },
  ],
};
